import { useCallback } from 'react';
import { EKeysMap } from '../../../internal/constants/EKeysMap';
export var useTagOnKeyDown = function useTagOnKeyDown(callback) {
  return useCallback(function (e) {
    if (e.key === EKeysMap.BACKSPACE || e.key === EKeysMap.DELETE) {
      callback();
    }
  }, [callback]);
};